import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';

const UsersGroupsAddSuccessToast = ({ groups }) => (
  <PositiveToast className="aridhia-users-groups-add-success-toast">
    {groups.length === 1 && (
    <FormattedMessage id="users.groups.toast.add.success" values={{ name: groups[0].name }} />
    )}
    {groups.length > 1 && (
      <FormattedMessage
        id="users.groups.toast.add.successes"
        values={{ name: groups[0].name, count: groups.length - 1 }}
      />
    )}
  </PositiveToast>
);

export default UsersGroupsAddSuccessToast;
